import { createContext } from 'react';

import type { GaugeChartSlotsConfig } from '../types/gauge-chart-config.js';

type GaugeChartLabelsContextProps = Omit<
  GaugeChartSlotsConfig,
  'thresholds' | 'thresholdsIndicators' | 'colorRules' | 'intents'
>;

export const GaugeChartLabelsContext =
  createContext<GaugeChartLabelsContextProps>(
    {} as GaugeChartLabelsContextProps,
  );
